import { select, takeLatest } from '@redux-saga/core/effects'
import { put } from 'redux-saga/effects'
import { getPhoneDetailSelector } from '../selectors/getPhoneDetail.selector'
import { getPhoneDetailsSelector } from '../../patientDemographics/selectors/getPhoneDetails.selector'
import { setPhoneDetails } from '../../patientDemographics/store/patientDemographics.actions'
import { OptionsConstants } from '../store/options.constants'
import { IPhoneDetail, IPhoneDetails } from '../store/options.types'

export function* deletePhoneDetails() {
  const phoneDetails: IPhoneDetails = yield select(getPhoneDetailsSelector)
  const phoneDetail: IPhoneDetail = yield select(getPhoneDetailSelector)
  if (phoneDetail && phoneDetails) {
    yield put(setPhoneDetails(phoneDetails.filter((phone) => phone.key !== phoneDetail?.key)))
  }
}

export function* deletePhoneDetailsSaga() {
  yield takeLatest([OptionsConstants.DELETE_PHONE], deletePhoneDetails)
}
